import * as Yup from "yup";

export const initialValues = {
  tagType: "regular",
  tagName: "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    tagType: Yup.string().required("This field is required"),
    tagName: Yup.string().required("This field is required"),
  });
